export default class PostainfoClass {

    constructor() {
        this.infoData = null;
    }

    init() {
        let self = this;

        if (this.infoData == null) {
            this.initdataLoad();
        }

        if (+$('input[name="atvetel_helye"]:checked').val() == 10) {
            $(".posta-valaszto #cityselect").on("keyup click", () => {
                this.searchPosta();
            });

            $(".posta-valaszto #postaselect").on("change", () => {
                // PostaInfo.selectPostaItem($(this).val());
            });

            $(".posta-valaszto .selector-select-display").on("click", () => {
                let search = $(".posta-valaszto #cityselect").val();
                let result = [];

                for (let i = 0; i < this.infoData.length; i++) {
                    if (this.infoData[i].city.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                        result.push(this.infoData[i]);
                        break;
                    }
                }

                this.fillPostaSelectorByCity(search);
            });
        }

        if (typeof postaSelected == "undefined" || postaSelected == "") {
            setTimeout(function () {
                $(".posta-valaszto #cityselect").trigger('click').focus();
            }, 500);
        }
    }


    initdataLoad() {
        $.get('/webshop_hu/kosar/postainfo/list', { formtoken: formtoken }, (result) => {
            this.infoData = result;
            this.fillSelected();

            if (+$('input[name="atvetel_helye"]:checked').val() == 10) {
                $(".posta-valaszto #cityselect").on("keyup click", () => {
                    this.searchPosta();
                });

                $(".posta-valaszto #postaselect").on("change", () => {
                    // PostaInfo.selectPostaItem($(this).val());
                });

                $(".posta-valaszto .selector-select-display").on("click", () => {
                    var search = $(".posta-valaszto #cityselect").val();
                    var result = [];

                    for (var i = 0; i < this.infoData.length; i++) {
                        if (this.infoData[i].city.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                            result.push(this.infoData[i]);
                            break;
                        }
                    }

                    this.fillPostaSelectorByCity(search);
                });
            }

            if (typeof postaSelected == "undefined" || postaSelected == "") {
                setTimeout(() => {
                    $(".posta-valaszto #cityselect").trigger('click').focus();
                }, 500);
            }
        });
    }

    // az infoData json tömbben keres
    searchPosta() {
        let search = $(".posta-valaszto #cityselect").val();
        let result = [];

        if (this.infoData == null) {
            this.initdataLoad();
            return;
        }

        if (search.length > 2) {
            for (let i = 0; i < this.infoData.length; i++) {
                if (this.infoData[i].city.toLowerCase().indexOf(search.toLowerCase()) > -1) {
                    result.push(this.infoData[i]);
                }
            }
        } else {
            for (let i = 0; i < this.infoData.length; i++) {
                result.push(this.infoData[i]);
            }
        }
        this.showSearchResults(result, search);
    }

    // a keresés eredményét jeleníti meg
    showSearchResults(data, search, noOpen) {
        if (noOpen == undefined) {
            var noOpen = false;
        }
        let html = "";
        for (let i = 0; i < data.length; i++) {
            html += '<a href="" class="city-selector" data-city="' + data[i].city + '">' + this.highlightSelectedText(data[i].city, search) + '</a>';
        }

        $(".posta-valaszto .cityselect-result").html(html);
        if (!noOpen) {
            $(".posta-valaszto .cityselect-result").removeClass("d-none");
        }

        $('#postaselect').val("");

        this.initCitySelectorItems();
    }

    initCitySelectorItems() {
        let self = this;
        $(".posta-valaszto .posta-selectors-kont .city-selector").on("click", function (e) {
            e.preventDefault();
            let city = $(this).data("city");
            $(".posta-valaszto .cityselect-result").html("").addClass("d-none");
            self.fillPostaSelectorByCity(city);
        });
    }

    fillPostaSelectorByCity(city, noOpen) {
        if (noOpen == undefined) {
            var noOpen = false;
        }
        $('#postaselect').val("");

        $(".posta-valaszto #cityselect").val(city);
        $(".posta-valaszto #cityselect").parent().find('.placeholder-text').addClass('smallest');

        if (!noOpen) {
            $('.select-items-kont').html("").removeClass("d-none");
        }
        let selectItem = $('<a>');
        selectItem.className = "select-posta-item";
        selectItem.addClass("select-posta-item");
        selectItem.text("Válasszon");
        selectItem.appendTo('.select-items-kont');

        for (let i = 0; i < this.infoData.length; i++) {
            if (this.infoData[i].city == city) {
                for (let j = 0; j < this.infoData[i].items.length; j++) {
                    let option = $('<a>');
                    option.data('itemId', this.infoData[i].items[j].id);
                    option.addClass("select-posta-item " + this.infoData[i].items[j].id);

                    let optiontext = this.infoData[i].items[j].address + " (" + this.infoData[i].items[j].city + " " + this.infoData[i].items[j].point_type_text + ") ";

                    if (city == 'Budapest') {
                        optiontext = this.romanize(this.infoData[i].items[j].district) + ". " + optiontext;
                    }
                    option.text(optiontext);

                    option.on("click", (e) => {
                        e.preventDefault();
                        let id = $(e.target).data("itemId");
                        $('#postaselect').val(id);
                        this.selectPostaItem(id);
                    });

                    option.appendTo('.select-items-kont');
                }
            }
        }
    }

    selectPostaItem(id) {
        let data = null;
        for (let i = 0; i < this.infoData.length; i++) {
            for (let j = 0; j < this.infoData[i].items.length; j++) {
                if (this.infoData[i].items[j].id == id) {
                    data = this.infoData[i].items[j];
                    break;
                }
            }
        }

        $(".posta-valaszto [name=pickup_posta_data]").val('');
        $(".posta-valaszto .posta-address .address").html('');
        $(".posta-valaszto .posta-address").addClass("d-none");
        $('.select-items-kont').html("").addClass("d-none");

        if (data != undefined) {
            let optiontext = data.address + " (" + data.point_type_text + ") ";
            $('.selector-select-display .display-value').text(optiontext);

            $.get('/webshop_hu/kosar/postainfo/item', { formtoken: formtoken, id: data.id }, (result) => {
                $(".posta-valaszto [name=pickup_posta_data]").val(result.id);

                let formattedHours = [];
                if (
                    result.working_hours != undefined
                    && result.working_hours.days != undefined
                    && result.working_hours.days.length > 0
                ) {
                    for (let i = 0; i < result.working_hours.days.length; i++) {
                        let curr = result.working_hours.days[i];
                        formattedHours[curr.day] = curr.From1 + " - " + curr.To1;
                        formattedHours.push(curr.day + ": " + curr.From1 + " - " + curr.To1);
                    }
                }

                $(".posta-valaszto .posta-address").removeClass("d-none");
                $(".posta-valaszto .posta-address .address").html(
                    result.name + " (" + result.point_type_text + ")<br>" +
                    result.address + "<br><br>"
                    + "<b>Nyitvatartás:</b><br>" + formattedHours.join("<br>")
                );

                let mapOptions = {
                    center: new google.maps.LatLng(result.gps_lat, result.gps_lon),
                    zoom: 15
                };

                $('#postamap').removeClass('d-none');
                let map = new google.maps.Map(document.getElementById('postamap'), mapOptions);

                let marker = new google.maps.Marker({
                    position: new google.maps.LatLng(result.gps_lat, result.gps_lon),
                    map: map,
                    title: result.name
                });

                map.setCenter(new google.maps.LatLng(result.gps_lat, result.gps_lon));
                marker.setPosition(new google.maps.LatLng(result.gps_lat, result.gps_lon));


                $.get('/index.php/webshop/services/kosar_load_cimadatok_template?t=' + (new Date().getTime()), (res) => {
                    $('.cimadatok-container').html(res);
                    Events.cimadatokInitEvents();
                }, 'html');

            });
        } else {
            let optiontext = $('.selector-select-display .display-value').data('placeholder');
            $('.selector-select-display .display-value').text(optiontext);
        }
    }

    fillSelected() {
        try {
            if (postaSelected != undefined && postaSelected != '') {
                postaSelected = JSON.parse(postaSelected);
                $(".posta-valaszto").addClass("opened");
                $(".posta-valaszto .posta-address").removeClass("d-none");
                $(".posta-valaszto .posta-address .address").html(
                    postaSelected.cegnev + " (" + postaSelected.point_type_text + ")<br>" +
                    postaSelected.telepules + "<br>" +
                    postaSelected.cim
                );
                $(".posta-valaszto #cityselect").val(postaSelected.telepules);
                $(".posta-valaszto #cityselect").parent().find('.placeholder-text').addClass('smallest');

                setTimeout(() => {
                    this.fillPostaSelectorByCity(postaSelected.telepules, true);
                    setTimeout(() => {
                        $(".posta-valaszto #postaselect").val(postaSelected.id);
                        if ($('.select-items-kont .select-posta-item.' + postaSelected.id).length > 0) {
                            $('.select-items-kont .select-posta-item.' + postaSelected.id).trigger('click');
                        }
                    }, 500);
                }, 500);


            }
        } catch (e) {
        }
    }

    // egy b tag-et rak a text-ben szereplő search köré
    highlightSelectedText(text, search) {
        return text.replace(new RegExp(search, 'gi'), function (m) {
            return "<b>" + m + "</b>";
        });
    }

    // convert arab számot római számmá
    romanize(num) {
        if (!+num)
            return false;
        var digits = String(+num).split(""),
            key = ["", "C", "CC", "CCC", "CD", "D",
                "DC", "DCC", "DCCC", "CM",
                "", "X", "XX", "XXX", "XL", "L",
                "LX", "LXX", "LXXX", "XC",
                "", "I", "II", "III", "IV", "V",
                "VI", "VII", "VIII", "IX"],
            roman = "",
            i = 3;
        while (i--)
            roman = (key[+digits.pop() + (i * 10)] || "") + roman;
        return Array(+digits.join("") + 1).join("M") + roman;
    }
}

// A view.js fogja beállítani window.Postainfo-ként a globális eléréshez
